module.exports = __webpack_public_path__ + "assets/img/legal.e1a8dfaf.svg";